<script>

import { mapActions } from 'vuex';
import request from '@/services/request';

import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';

export default {
    name: "modal-program-installment",

    components: {
        DatePicker
    },

    data() {
        return {
            errors: {},
            form: {
                id: "",
                program_id: "",
                type: 2,      // 1 normal, 2 extra
                number: "",   // opcional (yo lo llenaría en backend)
                amount: "",
                due_date: "",
            }
        };
    },

    methods: {
        closeModal() {
            this.errors = {};
            this.form = { id: "", program_id: "", type: 2, number: "", amount: "", due_date: "" };
            this.$modal.hide("modalProgramInstallment");
        },

        async saveInstallment() {
            let endpoint = "/programs_additional";
            let payload = {
                program_id: this.form.program_id,
                type: this.form.type,
                number: this.form.number,   // si lo manejas en backend, NO lo mandes
                amount: this.form.amount,
                due_date: this.form.due_date,
            };

            if (this.form.id) {
                payload._method = "PUT";
                endpoint = `/programs_additional/${this.form.id}`;
            }

            try {
                let { data } = await request.post(endpoint, payload);
                this.successNotification(data.message);
                this.closeModal();
                Event.$emit("event-reload-program-relations");
            } catch (error) {
                this.errors = {};
                if (error.response) this.errors = await this.errorNotification(error);
            }
        },

        ...mapActions({
            errorNotification: "alert/error",
            successNotification: "alert/success"
        })
    },

    created() {
        Event.$on("event-open-program-contribution", (installment) => {
            this.errors = {};

            if (installment.id) {
                this.form.id = installment.id;
                this.form.program_id = installment.program_id;
                this.form.type = installment.type;
                this.form.number = installment.number;
                this.form.amount = installment.amount;
                this.form.due_date = installment.due_date;
            } else {
                this.form.program_id = installment.program_id;
                this.form.type = installment.type ?? 2;
            }

            this.$modal.show("modalProgramInstallment");
        });
    }
};

</script>

<template>
    <modal name="modalProgramInstallment" :width="'50%'" :height="'auto'" :click-to-close="false">
        <form @submit.prevent="saveInstallment">
            <button type="button" class="btn btn-danger btn-sm btn-closed" @click="closeModal">
                <i class="fa-solid fa-xmark"></i>
            </button>

            <div class="modal-header">
                <h5 class="modal-title">
                    {{ form.id ? "Editar aportación (installment)" : "Nueva aportación (installment)" }}
                </h5>
            </div>

            <div class="modal-body">
                <div class="row">
                 
                    <!-- Número: yo recomiendo NO editarlo y que lo asigne el backend -->
                    <div class="col-md-12 mt-3">
                        <label>Número</label>
                        <input type="number" class="form-control" v-model.number="form.number" disabled>
                    </div>

                    <div class="col-md-12 mt-3">
                        <label>Monto</label>
                        <input type="number" step="0.01" class="form-control" v-model="form.amount">
                        <div class="text-danger" v-if="errors.amount">{{ errors.amount[0] }}</div>
                    </div>

                    <div class="col-md-12 mt-3">
                        <label>Fecha (opcional)</label>
                        <date-picker v-model="form.due_date" valueType="format"></date-picker>
                        <div class="text-danger" v-if="errors.due_date">{{ errors.due_date[0] }}</div>
                    </div>

                    <div class="col-12 mt-4">
                        <hr>
                        <button type="submit" class="btn float-right btn-outline-success">
                            <i class="fas fa-save"></i> Guardar
                        </button>
                        <button type="button" @click="closeModal" class="btn float-left btn-outline-warning">
                            <i class="fas fa-undo-alt"></i> Cancelar
                        </button>
                    </div>

                </div>
            </div>
        </form>
    </modal>
</template>
